const defaultEmptyCb: any = () => {
    // for linters only
};

const fallbackCopyTextToClipboard = (
    text: string,
    onCopy: () => void,
    onFailure: (error: any) => void,
) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    textArea.style.width = '0';
    textArea.style.height = '0';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        const successful = document.execCommand('copy');

        if (successful) {
            onCopy();
        } else {
            onFailure('execCommand "copy" failed');
        }
    } catch (error) {
        onFailure(error);
    } finally {
        document.body.removeChild(textArea);
    }
};

export const copyTextToClipboard = async (
    text: string,
    onCopy: () => void = defaultEmptyCb,
    onFailure: (error: any) => void = defaultEmptyCb,
) => {
    if (!window.navigator.clipboard) {
        fallbackCopyTextToClipboard(text, onCopy, onFailure);
        return;
    }

    try {
        await window.navigator.clipboard.writeText(text);

        onCopy();
    } catch (error) {
        onFailure(error);
    }
};
